exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainContent[data-v-3ef5f20e]{padding:0 60px}.topSubMenu[data-v-3ef5f20e]{padding:0 60px;margin:10px 0 5px}.selectedMenu li a[data-v-3ef5f20e]{color:#510087;font-weight:700}.customCheck[data-v-3ef5f20e]{height:30px;width:30px;border:1px solid #fcfcfc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ef5f20e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informes/Listplantilla.vue
// module id = 1036
// module chunks = 2